import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Check } from 'lucide-react';
const CHECKOUT_URL = 'https://noveliahub.com/cart/50875095482404:1';
export function Pricing() {
  const handleCheckout = () => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout');
    }
  };
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const features = ['Descarga instantánea', '2 PDFs de alta resolución', 'Imprime las veces que quieras', 'Compatible carta y A4', 'Bilingüe Español + English', 'Acceso inmediato tras la compra'];
  return <section id="pricing" ref={ref} className="w-full bg-gradient-to-b from-amber-50 to-orange-100 py-16 md:py-24" data-id="element-107">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl shadow-2xl p-8 sm:p-12" data-id="element-109">
          <h2 className="font-fredoka text-3xl sm:text-4xl font-bold text-gray-900 text-center mb-8" data-id="element-110">
            Todo esto por solo...
          </h2>

          <div className="text-center mb-8" data-id="element-111">
            <p className="font-nunito text-2xl text-gray-500 line-through mb-2" data-id="element-112">
              $30.97
            </p>
            <div className="flex items-center justify-center gap-3 mb-4" data-id="element-113">
              <span className="font-fredoka text-xl sm:text-2xl font-bold text-orange-600" data-id="element-114">
                HOY SOLO
              </span>
              <span className="font-fredoka text-5xl sm:text-6xl font-bold text-orange-600" data-id="element-115">
                $6.36
              </span>
              <span className="font-nunito text-xl text-gray-600" data-id="element-116">USD</span>
            </div>
          </div>

          <div className="bg-orange-50 rounded-2xl p-6 mb-8" data-id="element-117">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-118">
              {features.map((feature, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -10
            }} animate={isInView ? {
              opacity: 1,
              x: 0
            } : {}} transition={{
              delay: 0.1 * index,
              duration: 0.4
            }} className="flex items-center gap-2" data-id="element-119">
                  <div className="bg-green-500 rounded-full p-1 flex-shrink-0" data-id="element-120">
                    <Check className="w-4 h-4 text-white" data-id="element-121" />
                  </div>
                  <span className="font-nunito text-sm sm:text-base text-gray-800" data-id="element-122">
                    {feature}
                  </span>
                </motion.div>)}
            </div>
          </div>

          <motion.a href={CHECKOUT_URL} onClick={handleCheckout} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="block w-full text-center bg-orange-500 hover:bg-orange-600 text-white font-fredoka font-bold text-xl sm:text-2xl py-6 rounded-full shadow-lg hover:shadow-xl transition-all" data-id="element-123">
            COMPRAR AHORA / BUY NOW — $6.36
          </motion.a>
        </motion.div>
      </div>
    </section>;
}